<template>
	<v-card>
		<v-card-text class="sgnl-py-8 sgnl-pl-16 sgnl-pr-20">
			<v-timeline density="compact">
				<v-timeline-item
					v-for="(taskEvent, i) in timelineEvents"
					:key="i"
					size="small"
					:dot-color="util.taskStatusColor(taskEvent.Status)"
					:icon="util.taskStatusIcon(taskEvent.Status)"
					fill-dot
				>
					<div class="timeline-row">
						<span class="timeline-status sgnl-font-weight-bold">
							{{ taskEvent.Status }}
						</span>
						<span class="timeline-timestamp">
							{{ formatTimestamp(taskEvent.Timestamp) }}
						</span>
						<span class="timeline-duration">
							{{
								timelineEvents[i + 1]
									? util.formatDuration(taskEvent.Timestamp, timelineEvents[i + 1].Timestamp)
									: ""
							}}
						</span>
					</div>
				</v-timeline-item>
			</v-timeline>
		</v-card-text>
	</v-card>
</template>

<script lang="ts">
import { TaskStatusTransition } from "@/types/api/tasks";
import * as util from "@/js/utilities";
import { defineComponent, PropType } from "vue";
import moment from "moment";

// Types

// Libraries

// Utilities

// Components

// Stores

// Global variables

export default defineComponent({
	name: "TaskStatusTransitionTooltip",
	components: {},

	props: {
		taskStatusTransitions: {
			type: Array as PropType<TaskStatusTransition[]>,
			default: () => [],
		},
	},
	data: (): { d1: undefined | string } => ({
		d1: undefined,
	}),
	setup() {
		return { util };
	},

	methods: {
		formatTimestamp(timestamp) {
			const timestampMs = util.convertToMilliseconds(timestamp);
			return `${util.millisecondsSinceEpochToDateString(timestampMs)} at ${moment(timestampMs).format("HH:mm:ss")}`;
		},
	},
	computed: {
		timelineEvents(): TaskStatusTransition[] {
			return this.taskStatusTransitions;
		},
	},
});
</script>

<style lang="scss" scoped>
.timeline-row {
	display: flex;
	align-items: center;
	gap: var(--sgnl-space-16);
	white-space: nowrap;
}
.timeline-status {
	min-width: 7em;
}
.timeline-timestamp {
	min-width: 14em;
	text-align: right;
}
.timeline-duration {
	min-width: 5em;
	text-align: right;
}
</style>
